import React from 'react'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/background/bg-1.png'
import bg2 from '../../assets/images/background/bg-2.png'
import offerimg1 from '../../assets/images/resource/offer-image-1.jpg'
import offerimg2 from '../../assets/images/resource/offer-image-2.jpg'
import offerimg3 from '../../assets/images/resource/offer-image-3.jpg'
import Pdf from  '../../../src/Menu.pdf'

function Offer() {

  const offers = [
    {
      image: offerimg1,
      title: 'LASSI',
      link: {Pdf}
    },
    {
      image: offerimg2,
      title: 'NASHTA',
      link: {Pdf}
    },
    {
      image: offerimg3,
      title: 'CHAI',
      link: {Pdf}
    }
  ];

  return (
    <>
      <section className="we-offer-section">
        <div className="left-bot-bg"><img src={bg1} alt="" title="" /></div>
        <div className="right-top-bg"><img src={bg2} alt="" title="" /></div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Flavors for royalty</span></div>
            <div className="pattern-image">
              <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
            </div>
            <h2>We Offer Top Notch</h2>
            <div className="text">“Every bite bursts with flavor—Pakistani food is a masterpiece of spices!, No one does bold, comforting flavors like Pakistan!, From the rich gravies to the smoky BBQ, this cuisine is soul-satisfying, Pakistani food is not just a meal—it’s an experience.”</div>
          </div>
          <div className="row justify-content-center clearfix">
            {offers.map((offer, index) => (
              <div key={index} className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                  <div className="image"><Link to="#"><img src={offer.image} alt="" /></Link></div>
                  <h3><Link to="#">{offer.title}</Link></h3>
                  <div className="more-link"><Link to={Pdf} className="theme-btn btn-style-two clearfix" target="blank">View All Menu</Link></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Offer
